import { render, staticRenderFns } from "./NewsInstanceGroupsDeleteModal.vue?vue&type=template&id=6a43fefe&scoped=true&"
import script from "./NewsInstanceGroupsDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./NewsInstanceGroupsDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a43fefe",
  null
  
)

export default component.exports